import script from "./BalLink.vue?vue&type=script&lang=ts&setup=true"
export * from "./BalLink.vue?vue&type=script&lang=ts&setup=true"

import "./BalLink.vue?vue&type=style&index=0&id=43ce7cfa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ce7cfa"]])

export default __exports__